import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../translation/TranslationContext';

const RachelInterruptedNotice = () => {
  const { translate } = useTranslation();

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      test-id="rachel-interrupted-notice"
      sx={(theme) => ({
        '&::before': {
          content: '""',
          flexShrink: 0,
          width: 3,
          alignSelf: 'stretch',
          borderRadius: theme.shape.borderRadiusFull,
          backgroundColor: theme.palette.divider,
        },
      })}
    >
      <Typography variant="micro1" color="text.secondary">
        {translate(LangEnum.RACHEL_RESPONSE_INTERRUPTED)}
      </Typography>
    </Stack>
  );
};

export default RachelInterruptedNotice;
